import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { shareContent } from '../../../actions/spaces/ShareContentAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource, isSingleUnpublishedFlowDraft, isSingleUnShareableCollection} from './IEntityActionHelpers';
import { AppState } from '../../../state/AppState';

export const ShareContentAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.ShareContent,
  translateName: Messages.share_content_action,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    return FeatureFlags.newShareDialogEnabled && !anyItemIsEmbeddedDatasource(targetItems)
      && !isSingleUnpublishedFlowDraft(targetItems) && !isSingleUnShareableCollection(appState, targetItems);
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]) => {
    return shareContent(targetItems[0]);
  }
};
